<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-container>
          <v-row align="center" justify="center">
            <h1>{{ $t('parameters') }}</h1>
            <div class="mx-2" />
            <DialogButton
              section="parameters"
              subsection="main"
              :title="$t('parameters')"
              hideSubtitle
            />
          </v-row>
          <v-row align="center" justify="center">
            <h3 class="headline mb-1">{{ $t('manageServiceParams') }}</h3>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <GeneralParameters :externalsAuths="externalsAuths" />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" v-if="hasExternalsAuths">
            <v-col cols="12">
              <ExternalsAuthsList :externalsAuths="externalsAuths" />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row></v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogButton from '@/components/documentation/buttons/DialogButton'
import GeneralParameters from '@/components/params/GeneralParameters'
import ExternalsAuthsList from '@/components/params/ExternalsAuthsList'
import { getExternalsAuthsSubscription } from '@/services/externals-auths-service'

export default {
  components: {
    DialogButton,
    ExternalsAuthsList,
    GeneralParameters,
  },
  data() {
    return {
      externalsAuthsUnsubcribe: () => {},
      externalsAuths: [],
    }
  },
  async created() {
    this.externalsAuthsUnsubcribe = await getExternalsAuthsSubscription(
      (externalsAuths) => {
        this.externalsAuths = externalsAuths
      }
    )
  },
  async destroyed() {
    if (this.externalsAuthsUnsubcribe) this.externalsAuthsUnsubcribe()
  },
  computed: {
    ...mapGetters(['hasExternalsAuths']),
  },
}
</script>
